/**
 * ourskincare.js
 * - Post-add-to-cart upsell popup (bundle upgrade, colibri-style)
 * - Free shipping progress
 * - PDP delivery estimate
 */
(function () {
  'use strict';

  /* ---------------- Utilities ---------------- */

  function parseConfig() {
    var el = document.querySelector('[data-osk-upsell-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function parseJSONScript(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var format = moneyFormat || '{{amount_with_comma_separator}} kr';
    var noDecimals = String(Math.round(cents / 100));
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals);
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  /* ---------------- Upsell popup ---------------- */

  var config = parseConfig();
  var popup = document.getElementById('osk-upsell-popup');
  if (!config || !config.enabled || !popup) return;

  var panel = popup.querySelector('[data-osk-upsell-panel]');
  var lastFocused = null;
  var adding = false;

  function openPopup() {
    lastFocused = document.activeElement;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = popup.querySelector('.osk-upsell__close');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup() {
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  popup.addEventListener('click', function (event) {
    if (event.target.closest('[data-osk-upsell-close]')) closePopup();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  function classifyVariant(v, keyword) {
    var hay = [v.title, v.option1].join(' ').toLowerCase();
    var kw = (keyword || 'tilbud').toLowerCase();
    var n = 1;
    if (hay.indexOf('3') !== -1) n = 3;
    else if (hay.indexOf('2') !== -1) n = 2;
    return { n: n, special: hay.indexOf(kw) !== -1 };
  }

  function findAddedVariant(pdp, cart) {
    if (cart && cart.items) {
      for (var k = cart.items.length - 1; k >= 0; k--) {
        var item = cart.items[k];
        if (String(item.product_id) === String(pdp.id)) {
          for (var m = 0; m < pdp.variants.length; m++) {
            if (String(pdp.variants[m].id) === String(item.variant_id)) return pdp.variants[m];
          }
        }
      }
    }
    var input = document.querySelector('input[name="id"]');
    var addedId = input ? String(input.value) : null;
    if (addedId) {
      for (var i = 0; i < pdp.variants.length; i++) {
        if (String(pdp.variants[i].id) === addedId) return pdp.variants[i];
      }
    }
    return pdp.variants[0];
  }

  /*
    Tiered popup:
    - added 1x -> offer special 2x (199) vs regular 2x (229)
    - added 2x -> offer special 3x (279) vs regular 3x (299)
    - added 3x -> offer the extra-cream product (override setting), if set
  */
  function pickOffer(cart) {
    var override = parseJSONScript('[data-osk-upsell-override]');
    var pdp = parseJSONScript('[data-osk-upsell-product]');
    var keyword = config.specialKeyword || 'tilbud';

    if (!pdp) return null;
    var added = findAddedVariant(pdp, cart);
    if (!added) return null;
    var addedCls = classifyVariant(added, keyword);

    if (addedCls.n === 3) {
      if (override) {
        for (var i = 0; i < override.variants.length; i++) {
          var v = override.variants[i];
          if (v.available) return { product: override, variant: v, referencePrice: 0 };
        }
      }
      return null;
    }

    var targetN = addedCls.n + 1;
    var special = null;
    var regular = null;
    for (var j = 0; j < pdp.variants.length; j++) {
      var cand = pdp.variants[j];
      if (!cand.available) continue;
      if (String(cand.id) === String(added.id)) continue;
      var cls = classifyVariant(cand, keyword);
      if (cls.n !== targetN) continue;
      if (cls.special && !special) special = cand;
      if (!cls.special && !regular) regular = cand;
    }

    var target = special || regular;
    if (!target) return null;
    var referencePrice = 0;
    if (special && regular) referencePrice = regular.price;
    else if (target.compareAtPrice > target.price) referencePrice = target.compareAtPrice;

    return { product: pdp, variant: target, referencePrice: referencePrice };
  }

  var shownOffer = null;

  function currentOfferProduct() {
    return shownOffer && shownOffer.product ? shownOffer.product : null;
  }

  function renderPopup(offer, cart) {
    shownOffer = offer;
    var t = config.texts;
    var v = offer.variant;
    var price = formatMoney(v.price, config.moneyFormat);
    var refPrice = offer.referencePrice || 0;
    var compare = refPrice > v.price ? formatMoney(refPrice, config.moneyFormat) : (v.compareAtPrice > v.price ? formatMoney(v.compareAtPrice, config.moneyFormat) : null);
    var savings = refPrice > v.price ? refPrice - v.price : (v.compareAtPrice > v.price ? v.compareAtPrice - v.price : 0);

    var addedItem = null;
    if (cart && cart.items && cart.items.length) addedItem = cart.items[cart.items.length - 1];

    var html = '';
    html += '<div class="osk-upsell__added">';
    html += '<span class="osk-upsell__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="20 6 9 17 4 12"/></svg></span>';
    html += '<div class="osk-upsell__added-info">';
    html += '<strong>' + esc(t.added) + '</strong>';
    if (addedItem) html += '<span>' + esc(addedItem.product_title || addedItem.title || '') + '</span>';
    html += '</div></div>';

    html += '<div class="osk-upsell__shipping" data-osk-upsell-shipping></div>';

    html += '<div class="osk-upsell__recommend">';
    html += '<span class="osk-upsell__recommend-label">' + esc(t.recommended) + '</span>';
    html += '<div class="osk-upsell__offer">';
    if (offer.product.image) {
      html += '<img class="osk-upsell__img" src="' + esc(offer.product.image) + '" alt="' + esc(offer.product.title) + '" width="96" height="96" loading="lazy">';
    }
    html += '<div class="osk-upsell__offer-info">';
    html += '<strong class="osk-upsell__offer-title">' + esc(offer.product.title) + ' – ' + esc(v.title) + '</strong>';
    html += '<p class="osk-upsell__offer-text">' + esc(t.text) + '</p>';
    html += '<div class="osk-upsell__offer-price">';
    html += '<span>' + price + '</span>';
    if (compare) html += '<s>' + compare + '</s>';
    if (savings > 0) html += '<em class="osk-upsell__save-badge">Spar ' + formatMoney(savings, config.moneyFormat) + '</em>';
    html += '</div></div></div>';
    html += '<button type="button" class="osk-btn osk-btn--solid osk-upsell__add" data-osk-upsell-add data-variant-id="' + v.id + '">';
    html += esc(t.add) + ' · ' + price;
    html += '</button>';
    html += '</div>';

    html += '<div class="osk-upsell__actions">';
    html += '<a class="osk-upsell__cart-link" href="' + config.checkoutUrl + '">' + esc(t.cart) + '</a>';
    html += '<button type="button" class="osk-upsell__continue" data-osk-upsell-close>' + esc(t.continue) + '</button>';
    html += '</div>';

    panel.innerHTML = html;
    renderShipping(cart);
    openPopup();
  }

  function renderShipping(cart) {
    var slot = panel.querySelector('[data-osk-upsell-shipping]');
    if (!slot) return;
    var t = config.texts;
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var remaining = config.threshold - total;
    if (remaining <= 0) {
      slot.innerHTML = '<span class="osk-upsell__shipping-reached">' + esc(t.shippingReached) + '</span>';
    } else {
      slot.innerHTML = esc(t.shippingRemaining).replace('%AMOUNT%', '<strong>' + formatMoney(remaining, config.moneyFormat) + '</strong>');
    }
  }

  function removeOtherProductLines(productId, keepVariantId) {
    return fetchCart().then(function (cart) {
      var stale = cart.items.filter(function (item) {
        return String(item.product_id) === String(productId) && String(item.variant_id) !== String(keepVariantId);
      });
      if (!stale.length) return cart;
      var chain = Promise.resolve();
      stale.forEach(function (item) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        });
      });
      return chain.then(fetchCart);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  function notifyCartUpdate(cart) {
    var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    event.action = 'add';
    event.promise = Promise.resolve({
      cart: { totalQuantity: cart.item_count },
      detail: { itemCount: cart.item_count, source: 'osk-upsell-popup' }
    });
    document.dispatchEvent(event);
  }

  panel.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-osk-upsell-add]');
    if (!btn || adding) return;
    adding = true;
    btn.classList.add('is-loading');
    btn.disabled = true;

    var variantId = btn.getAttribute('data-variant-id');
    var offerProduct = currentOfferProduct();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch(config.cartAddUrl + '.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (offerProduct && offerProduct.id) {
          return removeOtherProductLines(offerProduct.id, variantId);
        }
        return fetchCart();
      })
      .then(function (cart) {
        /* One upsell step only: after accepting, go straight to success/checkout */
        renderSuccess(cart);
        notifyCartUpdate(cart);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        var t = config.texts;
        var err = panel.querySelector('[data-osk-upsell-error]');
        if (!err) {
          err = document.createElement('p');
          err.setAttribute('data-osk-upsell-error', '');
          err.className = 'osk-upsell__error';
          btn.parentNode.insertBefore(err, btn.nextSibling);
        }
        err.textContent = t.error;
      })
      .finally(function () {
        adding = false;
      });
  });

  function renderSuccess(cart) {
    var t = config.texts;
    var html = '';
    html += '<div class="osk-upsell__added osk-upsell__added--center">';
    html += '<span class="osk-upsell__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="20 6 9 17 4 12"/></svg></span>';
    html += '<div class="osk-upsell__added-info"><strong>' + esc(t.added) + '</strong></div>';
    html += '</div>';
    html += '<div class="osk-upsell__shipping" data-osk-upsell-shipping></div>';
    html += '<div class="osk-upsell__actions osk-upsell__actions--stack">';
    html += '<a class="osk-btn osk-btn--solid" href="' + config.checkoutUrl + '">' + esc(t.cart) + '</a>';
    html += '<button type="button" class="osk-upsell__continue" data-osk-upsell-close>' + esc(t.continue) + '</button>';
    html += '</div>';
    panel.innerHTML = html;
    renderShipping(cart);
  }

  /* Hook into Horizon's cart update flow (product-form dispatches on add) */
  document.addEventListener(
    'shopify:cart:lines-update',
    function (event) {
      if (!event || event.action !== 'add') return;
      if (popup.classList.contains('is-open')) return;

      event.promise
        .then(function (payload) {
          var detail = payload && payload.detail ? payload.detail : {};
          if (detail.didError) return;
          if (detail.source === 'osk-upsell-popup') return;

          /* One bundle at a time: swap an older bundle of the same product out */
          var pdp = parseJSONScript('[data-osk-upsell-product]');
          var addedId = null;
          try {
            var input = document.querySelector('input[name="id"]');
            addedId = input ? String(input.value) : null;
          } catch (e) {}
          if (pdp && pdp.id && addedId) {
            removeOtherProductLines(pdp.id, addedId).then(function (cart) {
              notifyCartUpdate(cart);
            });
          }

          var offer = pickOffer();
          var drawerAlreadyOpen = Boolean(document.querySelector('theme-drawer[open]'));

          if (offer && !drawerAlreadyOpen) {
            fetchCart().then(function (cart) {
              var refreshed = pickOffer(cart);
              renderPopup(refreshed || offer, cart);
            });
          } else if (!drawerAlreadyOpen) {
            // No offer: restore native auto-open behaviour
            var drawer = document.querySelector('cart-drawer-component');
            var themeDrawer = drawer && drawer.closest('theme-drawer');
            if (themeDrawer && themeDrawer.open) themeDrawer.open();
          }
        })
        .catch(function () {});
    },
    false
  );

  /* ---------------- Delivery estimate (PDP) ---------------- */

  function initDelivery() {
    var blocks = document.querySelectorAll('[data-osk-delivery]');
    if (!blocks.length) return;

    var locale = document.documentElement.lang || 'da';

    blocks.forEach(function (block) {
      if (block.hasAttribute('data-unavailable')) return;

      var cutoff = (block.getAttribute('data-cutoff') || '12:00').split(':');
      var cutoffH = parseInt(cutoff[0], 10) || 0;
      var cutoffM = parseInt(cutoff[1], 10) || 0;
      var shipDays = parseInt(block.getAttribute('data-shipping-days') || '2', 10) || 2;

      var now = new Date();
      var ship = new Date(now);
      var afterCutoff =
        now.getHours() > cutoffH || (now.getHours() === cutoffH && now.getMinutes() >= cutoffM);
      ship.setDate(now.getDate() + (afterCutoff ? 1 : 0));

      var addedDays = 0;
      while (addedDays < shipDays) {
        ship.setDate(ship.getDate() + 1);
        var day = ship.getDay();
        if (day !== 0 && day !== 6) addedDays++;
      }

      var dateSlot = block.querySelector('[data-osk-delivery-date]');
      var subSlot = block.querySelector('[data-osk-delivery-sub]');
      var formatted = ship.toLocaleDateString(locale === 'da' ? 'da-DK' : locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      });

      if (dateSlot) dateSlot.textContent = ' – levering ' + formatted;
      if (subSlot) subSlot.textContent = 'Bestil inden kl. ' + String(cutoffH).padStart(2, '0') + ':' + String(cutoffM).padStart(2, '0');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDelivery);
  } else {
    initDelivery();
  }
})();

/* ---------------- PDP media badges (NYHED / -%) ---------------- */

(function () {
  'use strict';

  function getConfig() {
    var el = document.querySelector('[data-osk-upsell-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function initMediaBadges() {
    var cfg = getConfig();
    if (!document.querySelector('[data-osk-upsell-product]')) return;
    if (!cfg || !cfg.badgeNew) return;

    var gallery = document.querySelector('.product-information media-gallery');
    if (!gallery) return;

    function currentVariant() {
      var script = document.querySelector('variant-picker script[type="application/json"]');
      if (!script) return null;
      try { return JSON.parse(script.textContent); } catch (e) { return null; }
    }

    function render() {
      var badges = gallery.querySelector('.osk-media-badges');
      if (!badges) {
        badges = document.createElement('div');
        badges.className = 'osk-media-badges';
        gallery.insertBefore(badges, gallery.firstChild);
      }

      var html = '';
      if (cfg.badgeNew) {
        html += '<span class="osk-media-badge osk-media-badge--new">' + esc(cfg.badgeNew) + '</span>';
      }

      var variant = currentVariant();
      if (variant && variant.compare_at_price > variant.price && variant.price > 0) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<span class="osk-media-badge osk-media-badge--sale">-' + pct + ' %</span>';
      }

      badges.innerHTML = html;
    }

    render();

    var sectionEl = gallery.closest('.product-information') || gallery;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (!gallery.querySelector('.osk-media-badges')) render();
      });
    });
    observer.observe(sectionEl, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaBadges);
  } else {
    initMediaBadges();
  }
})();

/* ---------------- Cart guard: special-offer lines are capped at 1 ---------------- */

(function () {
  'use strict';

  function getConfig() {
    var el = document.querySelector('[data-osk-upsell-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getOverride() {
    var el = document.querySelector('[data-osk-upsell-override]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function enforceCaps() {
    var cfg = getConfig();
    if (!cfg) return;
    var kw = (cfg.specialKeyword || 'tilbud').toLowerCase();
    var override = getOverride();

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = cart.items.filter(function (item) {
          if (item.quantity <= 1) return false;
          var vt = String(item.variant_title || '').toLowerCase();
          var isSpecial = vt.indexOf(kw) !== -1;
          var isExtra = override && String(item.product_id) === String(override.id);
          return isSpecial || isExtra;
        });
        if (!bad.length) return;

        var chain = Promise.resolve();
        bad.forEach(function (item) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: item.key, quantity: 1 })
            });
          });
        });

        chain.then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (cart2) {
          var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
          event.action = 'update';
          event.promise = Promise.resolve({
            cart: { totalQuantity: cart2.item_count },
            detail: { itemCount: cart2.item_count, source: 'osk-quantity-guard' }
          });
          document.dispatchEvent(event);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('shopify:cart:lines-update', function () {
    setTimeout(enforceCaps, 700);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceCaps);
  } else {
    enforceCaps();
  }
})();
